import React from 'react';
import moment from 'moment';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import CircularProgress from '@material-ui/core/CircularProgress';
import useTranslation from 'Hooks/useTranslation';

const formatJobDate = (value) => (value ? moment(value).format('DD-MMM-YY, HH:mm') : null);

/**
 * Job picker as a table: one header row + rows on the same CSS grid, so columns line up
 * regardless of content. The body is the scroll container (listRef) for paged loading.
 */
const JobTableList = ({
    jobs = [],
    value,
    onChange,
    isRowDisabled,
    isRowMuted,
    licensesNames,
    listRef,
    isLoading = false,
}) => {
    const translation = useTranslation();

    const licenseName = (job) => (
        licensesNames?.find((ln) => ln.licenseId === job.licenseId)?.name || job.licenseId || '—'
    );

    return (
        <div className="jobTable">
            <div className="jobTableHead" role="row">
                <span className="jobTableCell jobTableCell--radio" aria-hidden="true" />
                <span className="jobTableCell jobTableCell--name">{translation.dashboardJobsLabel || 'Job'}</span>
                <span className="jobTableCell jobTableCell--license">{translation.dashboardLicenseLabel || 'License'}</span>
                <span className="jobTableCell jobTableCell--date">{translation.dashboardStartTimeLabel}</span>
                <span className="jobTableCell jobTableCell--date">{translation.dashboardStopTimeLabel}</span>
            </div>
            <div className="jobTableBody" ref={listRef}>
                <RadioGroup aria-label="jobs" name="jobs" value={value} onChange={onChange}>
                    {jobs.map((job) => {
                        const id = String(job.id);
                        const disabled = Boolean(isRowDisabled?.(job));
                        const muted = disabled || Boolean(isRowMuted?.(job));
                        const selected = value === id;
                        const stop = formatJobDate(job.stopTime);
                        return (
                            <label
                                key={job.id}
                                className={`jobTableRow${selected ? ' jobTableRow--selected' : ''}${muted ? ' jobTableRow--muted' : ''}${disabled ? ' jobTableRow--disabled' : ''}`}
                                id="settingsSelectJobModalJobLabel"
                            >
                                <span className="jobTableCell jobTableCell--radio">
                                    <Radio value={id} size="small" color="default" disabled={disabled} />
                                </span>
                                <span className="jobTableCell jobTableCell--name" title={job.name}>{job.name}</span>
                                <span className="jobTableCell jobTableCell--license" title={licenseName(job)}>{licenseName(job)}</span>
                                <span className="jobTableCell jobTableCell--date">{formatJobDate(job.startTime) || '—'}</span>
                                <span className="jobTableCell jobTableCell--date">
                                    {job.isLive
                                        ? <span className="jobTableLive">{translation.dashboardJobLiveLabel || 'Live'}</span>
                                        : (stop || '—')}
                                </span>
                            </label>
                        );
                    })}
                </RadioGroup>
                {!jobs.length && !isLoading ? (
                    <div className="jobTableEmpty">{translation.dashboardNoJobsLabel || 'No jobs found'}</div>
                ) : null}
            </div>
            {isLoading ? (
                <div className="jobTableLoader">
                    <CircularProgress size={28} />
                </div>
            ) : null}
        </div>
    );
};

export default JobTableList;
